<a class="supplierCodeLink" (click)="onClick($event)" style="cursor: pointer;">
    {{params.data.suppliercode}}
</a>